var _defs, _path, _path2, _rect, _path3, _path4, _path5, _polyline, _polyline2, _line, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b3018ea1-369b-4841-9e59-4803a2deafb3",
    "data-name": "\\u5716\\u5C64 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".aacdfdf9-8de0-407c-b7c7-74d302bfe2a2,.f2ae747c-03e4-4c6c-84a3-90f754652aa8{fill:none;}.aacdfdf9-8de0-407c-b7c7-74d302bfe2a2,.fe5f03d4-bc91-4b4a-b10b-730a1dce3148{stroke:#8e8e8e;}.aacdfdf9-8de0-407c-b7c7-74d302bfe2a2,.f2ae747c-03e4-4c6c-84a3-90f754652aa8,.fe5f03d4-bc91-4b4a-b10b-730a1dce3148{stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.be07db36-8241-4e1f-9077-c193fe85f1f5,.fe5f03d4-bc91-4b4a-b10b-730a1dce3148{fill:#1495c1;}.acbceb7f-ab42-4b8b-a735-1774f0d12d72,.ed57bde5-38a3-40f1-b23c-382753faa5e2{fill:#fff;}.f2ae747c-03e4-4c6c-84a3-90f754652aa8{stroke:#645346;}.ed57bde5-38a3-40f1-b23c-382753faa5e2{font-size:13.76px;font-family:NotoSansCJKtc-Regular-B5pc-H, Noto Sans CJK TC;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "html") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "aacdfdf9-8de0-407c-b7c7-74d302bfe2a2",
    d: "M22.3,78.2a4.1,4.1,0,0,0,4.1,4.2H67.3a4.2,4.2,0,0,0,4.2-4.2V21.8a4.2,4.2,0,0,0-4.2-4.2H36.7L22.3,32.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fe5f03d4-bc91-4b4a-b10b-730a1dce3148",
    d: "M22.3,32.1H32.6A4.1,4.1,0,0,0,36.7,28V17.6Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "be07db36-8241-4e1f-9077-c193fe85f1f5",
    x: 32.8,
    y: 59.5,
    width: 44.9,
    height: 14.99,
    rx: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "acbceb7f-ab42-4b8b-a735-1774f0d12d72",
    d: "M39.6,62.2v4.3h4.9V62.2h1.3V72.3H44.5V67.6H39.6v4.7H38.3V62.2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "acbceb7f-ab42-4b8b-a735-1774f0d12d72",
    d: "M50,63.3H46.9V62.2h7.5v1.1H51.3v9H50Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "acbceb7f-ab42-4b8b-a735-1774f0d12d72",
    d: "M64,67.9a32.7,32.7,0,0,1-.1-4.4h-.1a25.4,25.4,0,0,1-1.3,3.9l-1.7,4.9h-1l-1.7-4.8c-.4-1.5-.8-2.8-1.1-4h-.1c0,1.3-.1,3-.2,4.5l-.2,4.3H55.2l.7-10.1h1.7l1.7,4.9c.4,1.3.8,2.4,1,3.4h.1c.2-1,.6-2.1,1-3.4l1.8-4.9h1.7l.6,10.1H64.3Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "f2ae747c-03e4-4c6c-84a3-90f754652aa8",
    points: "39.2 52.8 32.4 45.9 39.2 39.1"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "f2ae747c-03e4-4c6c-84a3-90f754652aa8",
    points: "55.3 39.1 62.1 45.9 55.3 52.8"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "f2ae747c-03e4-4c6c-84a3-90f754652aa8",
    x1: 49.8,
    y1: 35.8,
    x2: 44.8,
    y2: 55.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "ed57bde5-38a3-40f1-b23c-382753faa5e2",
    transform: "translate(65.7 72.1)"
  }, "L")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.e4fa985d5e74bd651889e9eafd0729ce.svg";
export { ForwardRef as ReactComponent };